import state from './moduleMuralState'
import mutations from './moduleMuralMutations'
import actions from './moduleMuralActions'
import getters from './moduleMuralGetters'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
